import { useEditions } from "./use-editions";
import { maxBy, toNumber } from 'lodash';

export const useCurrentEdition = () => {
  const editions = useEditions();
  return maxBy(editions, edition => edition.numericValue || toNumber(edition.name));
};
